module.exports = __webpack_public_path__ + "img/pic-4.333c0956.png";